import { render, staticRenderFns } from "./ConfirmEliminar.vue?vue&type=template&id=9d5edea4"
import script from "./ConfirmEliminar.vue?vue&type=script&lang=js"
export * from "./ConfirmEliminar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports